import { useRootLoader } from "@/hooks/useRootLoader";
import {
  UNIZO_FEATURE_FLAGS,
  type UnizoFeatureFlagKey,
} from "@shared-domain/unizo/featureFlags";

/**
 * PRODUCT_DEV-620: テナント別フィーチャーフラグ (TenantProducts.featureFlags) の判定。
 *
 * 従来は各画面で
 *   `auth.memberships.find(...)?.products?.[0]?.featureFlags?.<key> ?? UNIZO_FEATURE_FLAGS.<key>.defaultValue ?? false`
 * を都度書いていたため、フラグを複数箇所で読む本課題を機にここへ集約する。
 * 判定順は従来と同一 (テナント設定 → レジストリの defaultValue → false)。
 *
 * URL param 方式の開発用フラグ (`useFeatureFlag`) とは別物なので混同しないこと。
 */
export function useTenantFeatureFlag(key: UnizoFeatureFlagKey): boolean {
  const { auth } = useRootLoader();
  const productId = auth?.info?.productId;
  const currentProduct = auth?.memberships
    ?.find((m) => m.tenantId === auth?.currentTenantId)
    ?.products?.find((p) => p.id === productId);
  return (
    currentProduct?.featureFlags?.[key] ??
    UNIZO_FEATURE_FLAGS[key].defaultValue ??
    false
  );
}
